import React from "react";
import {Translate} from "../../../../../../hooks/translate.hook";
import {ColumnsType} from "antd/es/table";
import {AgreementData} from "./common/model";
import Date from "../../../../../date/date";
import {Button, Space} from "antd";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

type MoveDirection = -1 | 1;

export const columnsFactory = (
    t: Translate,
    warehouses: Record<string, string>,
    onEdit: (item: AgreementData | null) => void,
    onMove: (index: number, direction: MoveDirection) => void,
    onDelete: (index: number) => void,
    itemsCount: number
): ColumnsType<AgreementData> => {
    return [
        {
            title: "",
            key: "sortActions",
            width: 80,
            render: (
                _: unknown,
                __: AgreementData,
                index: number
            ) => (
                <Space size={0}>
                    <Button
                        type="text"
                        aria-label="Move up"
                        disabled={index === 0}
                        icon={
                            <FontAwesomeIcon
                                icon={["fas", "arrow-up"]}
                            />
                        }
                        onClick={() => onMove(index, -1)}
                    />

                    <Button
                        type="text"
                        aria-label="Move down"
                        disabled={index === itemsCount - 1}
                        icon={
                            <FontAwesomeIcon
                                icon={["fas", "arrow-down"]}
                            />
                        }
                        onClick={() => onMove(index, 1)}
                    />
                </Space>
            )
        },
        {
            title: t("WAREHOUSES.TITLE"),
            dataIndex: "warehouse",
            key: "warehouse",
            ellipsis: true,
            render: (code: string) => warehouses[code] || code
        },
        {
            title: t("ACCOUNT.SETTINGS.WAREHOUSE.MAX_AMOUNT.TITLE"),
            dataIndex: "maxAmount",
            key: "maxAmount",
            width: 110
        },
        {
            title: t("NUMBER"),
            dataIndex: "number",
            key: "number",
            width: 110,
            ellipsis: true
        },
        {
            title: t("DATE"),
            dataIndex: "date",
            key: "date",
            width: 120,
            render: (date: string) => (
                <Date dateString={date}/>
            )
        },
        {
            title: "",
            key: "actions",
            width: 80,
            render: (
                _: unknown,
                item: AgreementData,
                index: number
            ) => (
                <Space size={0}>
                    <Button
                        type="text"
                        aria-label="Edit"
                        icon={
                            <FontAwesomeIcon
                                icon={["fas", "edit"]}
                            />
                        }
                        onClick={() => onEdit(item)}
                    />

                    <Button
                        type="text"
                        danger
                        aria-label="Delete"
                        icon={
                            <FontAwesomeIcon
                                icon={["fas", "trash"]}
                            />
                        }
                        onClick={() => onDelete(index)}
                    />
                </Space>
            )
        }
    ];
};
